import { container } from '@eureka/services/src/container';
export function addMaterialTrial() {
    return container.RnDHttp.post({
        url: `${process.env.VUE_APP_EUREKA_SERVICE_URI}/eureka/account-privilege/add-material-trial`,
    }).then(res => {
        return res?.data;
    });
}
